enum QUERY_KEYS {
  GET_CERTIFICATE = 'GET_CERTIFICATE',
  GET_CERTIFICATES = 'GET_CERTIFICATES',
  GET_DRAFTS = 'GET_DRAFTS',
  HELLO = 'HELLO',
}

export { QUERY_KEYS };
